// utils/rsa.js
import JSEncrypt from 'jsencrypt';
// crypto-js 用于辅助功能（如 Base64、哈希），不用于 RSA
import CryptoJS from 'crypto-js';

const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoliFKcH6/60qiMQanVhC
NsC5sh2D6F8yjS8pK1hZdINMJRCiioOkMy7HsdwB3qkl4g6IU1OyhFAZFb7akESD
U7xI23dB7mffg3ePmPZuo1m6UiKEorVZI7Gu/BGkQkWKto1NhbxdLkd5rS9bBLP8
SqLT/zXsChJ7ZdJ1SfBt/4BlFXRyGB0UCZTkzT0VQica/RIvrwRZDMdVmj2oOwoo
37xpguy6SizHMER+2JSRPJSa7xxdUD1FoqsxB2bpOqU+lH0DPCbAqkvoOvlOBItO
OlhV6vQ4ppmZZPuFYj+ZLmT/b7HGEOSeVGK1VKNCOv1pbKcSa2E+f8ZbMUl7q96/
BwIDAQAB
-----END PUBLIC KEY-----`;
let loading = false;

// RSA 加密
const encrypt = (plainText) => {
    try {
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(publicKey);
        const encrypted = encryptor.encryptOAEP(plainText);

        if (!encrypted) {
            throw new Error('RSA加密失败');
        }
        return encrypted;
    } catch (error) {
        console.error('RSA加密失败:', error);
        return "";
    }
};

// 混合加密：RSA 加密 AES 密钥 + AES 加密大数据
const hybridEncrypt = (data) => {
    // 1. 生成随机 AES 密钥
    const aesKey = CryptoJS.lib.WordArray.random(32); // 32字节 = 256位
    const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);
    // 2. 生成随机 IV（16字节，CBC 模式需要）
    const iv = CryptoJS.lib.WordArray.random(16);
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv)

    const plainText = typeof data === 'string' ? data : JSON.stringify(data);
    // 2. 用 AES 加密实际数据
    const encryptedData = CryptoJS.AES.encrypt(
        plainText,
        aesKey,
        {
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            iv: iv
        }
    ).toString();

    // 3. 用 RSA 加密 AES 密钥
    const encryptedKey = encrypt(aesKeyBase64);

    return {
        encryptedKey,
        encryptedData,
        iv: ivBase64,
    }
};

export default {
    encrypt,
    hybridEncrypt,
};
